module.exports = __webpack_public_path__ + "media/images/laverie-86025aa2928951993781b2e5a172a6e4.svg";